import React from 'react';

const Icon = ({ name }) => {
  switch (name) {
    case 'bra':
      return (
        <svg
          width="50"
          height="38"
          viewBox="0 0 50 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.4154 28.3946C23.4178 27.8267 23.3207 27.2627 23.1286 26.7283C22.2402 24.2089 20.4033 22.1359 18.0092 20.9507L17.6478 20.7786C16.6598 20.3083 15.6546 19.8724 14.6364 19.4622C13.3458 18.9431 12.1986 18.4097 11.8946 17.7543C11.8846 17.7314 11.843 17.7543 11.843 17.7543C11.7426 18.1114 10.8722 20.1563 10.1222 21.3049C9.37222 22.4536 7.20545 25.1667 5.74994 25.736L4.53678 26.245C3.92016 26.4903 1.57126 27.1055 1.61285 27.2489C1.69459 27.5213 2.37431 35.1029 2.63673 35.3811C2.89915 35.6593 6.79533 35.1272 6.79533 35.1272L8.83448 34.9609C11.7025 35.8629 13.8119 36.1339 16.069 35.9977C17.2736 35.9246 22.8676 35.3768 23.4154 28.6212C23.4111 28.5509 23.4154 28.4749 23.4154 28.3946Z"
            stroke="#18181e"
            strokeWidth="2.151"
            strokeLinejoin="round"
          />
          <path
            d="M26.9416 28.5379C28.2322 35.1028 33.5725 35.5932 34.7784 35.6219C37.0399 35.6778 38.9241 35.3652 41.7592 34.3585L43.8026 34.4503C43.8026 34.4503 47.8178 34.4876 48.0659 34.2008C48.314 33.914 48.7212 26.3138 48.7929 26.037C48.8302 25.8936 46.3551 25.7201 45.7313 25.4979L44.501 25.0332C43.0254 24.517 40.751 21.8627 39.971 20.7628C39.1909 19.6629 38.2258 17.6309 38.1125 17.2739C38.1125 17.2739 38.0709 17.2509 38.0594 17.2739C37.7827 17.9392 36.6484 18.5143 35.3822 19.0807C34.3784 19.5267 33.3946 19.9985 32.4238 20.5047L32.0696 20.6897C30.1449 21.7116 28.5672 23.2823 27.5367 25.2025C27.0647 26.0904 26.8394 27.0887 26.8843 28.0934C26.8918 28.2428 26.911 28.3915 26.9416 28.5379V28.5379Z"
            stroke="#18181e"
            strokeWidth="2.151"
            strokeLinejoin="round"
          />
          <path
            d="M11.9209 17.5451L12.3181 1.68652L18.0054 20.9509"
            stroke="#18181e"
            strokeWidth="2.151"
            strokeLinejoin="round"
          />
          <path
            d="M38.054 17.8585L38.2748 1.99707L31.5178 21.0105"
            stroke="#18181e"
            strokeWidth="2.151"
            strokeLinejoin="round"
          />
          <path
            d="M21.2876 33.7716C21.2876 33.7716 26.1632 31.2105 29.873 33.8333"
            stroke="#18181e"
            strokeWidth="2.151"
            strokeLinejoin="round"
          />
          <path
            d="M6.21309 25.4473C6.11127 26.1643 6.10697 33.753 11.311 35.5928"
            stroke="#18181e"
            strokeWidth="2.151"
            strokeLinejoin="round"
          />
          <path
            d="M44.0506 24.9355C44.1625 25.6525 44.2629 33.2398 39.0833 35.1471"
            stroke="#18181e"
            strokeWidth="2.151"
            strokeLinejoin="round"
          />
          <path
            d="M23.4155 28.3945L26.8844 28.0977"
            stroke="#18181e"
            strokeWidth="2.151"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'bralette':
      return (
        <svg
          width="51"
          height="41"
          viewBox="0 0 51 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M50.0711 29.552C48.5384 28.5131 48.0183 27.5542 47.2978 26.2259C47.1341 25.9233 46.9651 25.6115 46.7738 25.2801C46.5524 24.8648 46.2498 24.3238 45.9079 23.7906C44.577 21.7496 41.5705 18.7615 41.0229 18.2231L38.8339 1.84809C38.8032 1.61556 38.6904 1.40168 38.5157 1.24511C38.3411 1.08854 38.1162 0.999606 37.8817 0.994384C37.6473 0.989163 37.4186 1.068 37.2372 1.21664C37.0558 1.36529 36.9335 1.57393 36.8925 1.80486L32.6547 25.4949C30.8403 27.3525 27.4343 29.9908 25.3973 31.4855C23.3013 29.9423 19.7328 27.1782 17.9696 25.3167L13.7618 1.80748C13.72 1.57744 13.5974 1.36988 13.4162 1.22209C13.235 1.0743 13.0071 0.995968 12.7733 1.00118C12.5396 1.00639 12.3153 1.09479 12.1409 1.2505C11.9665 1.40622 11.8533 1.61904 11.8217 1.85071L9.61175 18.3816C8.78776 19.199 6.11798 21.9003 4.88658 23.7906C4.53943 24.3238 4.24206 24.8648 4.02067 25.2801C3.82941 25.6115 3.66042 25.9233 3.49667 26.2259C2.77617 27.5542 2.2561 28.5131 0.723401 29.552C0.575858 29.6518 0.458203 29.7899 0.382989 29.9514C0.307774 30.1129 0.277828 30.2918 0.296344 30.469L1.29849 39.901C1.32459 40.1491 1.44423 40.378 1.63307 40.541C1.82192 40.704 2.06578 40.789 2.31505 40.7787C2.31505 40.7787 5.37652 40.6555 8.82575 40.5088L12.613 40.3438L13.8103 40.2887C15.4059 40.2141 16.6006 40.1577 17.3604 40.1106L18.0324 40.0739C20.435 39.9429 23.051 39.8957 24.3964 39.8748C24.961 39.8656 25.3252 39.8617 25.3973 39.8617C25.4693 39.8617 26.0208 39.8617 26.8265 39.8813L27.5758 39.8957C28.1129 39.9075 28.722 39.9219 29.3679 39.9403L30.3622 39.9717L31.0447 39.9966L31.7324 40.0254C31.9617 40.0346 32.1922 40.0451 32.4202 40.0569C32.7621 40.0726 33.1014 40.0909 33.4341 40.1106C34.1939 40.1551 35.3886 40.2141 36.9842 40.2887L38.1815 40.3438L42.2818 40.5219C45.6001 40.6634 48.4795 40.7839 48.4795 40.7839H48.5188C48.7614 40.7837 48.9953 40.6938 49.1757 40.5316C49.3561 40.3693 49.4702 40.1461 49.496 39.9049L50.4982 30.4729C50.5174 30.2951 50.4878 30.1154 50.4126 29.9531C50.3373 29.7908 50.2193 29.6521 50.0711 29.552ZM37.7191 8.34438L39.071 18.4523L38.9125 18.5742C38.7815 18.6803 38.6374 18.7982 38.4973 18.9213C37.8399 19.5186 37.222 20.1579 36.6475 20.8352C36.1641 21.3894 35.6821 21.971 35.1712 22.588L37.7191 8.34438ZM12.9352 8.34438L15.4413 22.3745L15.1793 22.0653L14.7601 21.5636C14.0854 20.7632 13.5811 20.1907 13.1081 19.7099C12.9693 19.5671 12.8317 19.4296 12.6981 19.3012C12.5645 19.1728 12.4191 19.0392 12.2868 18.9213C12.1545 18.8034 12.0064 18.6803 11.8715 18.5742C11.8008 18.5178 11.7313 18.4641 11.6606 18.413L11.5859 18.3593L12.9352 8.34438ZM47.6384 38.7809C46.5302 38.7364 44.5429 38.6499 42.3657 38.5622L38.2706 38.3827L37.0759 38.3277C35.4869 38.2543 34.3013 38.1967 33.5481 38.1508C33.2101 38.1312 32.8643 38.1128 32.5158 38.0958L31.8163 38.0643L31.118 38.0355L30.4277 38.0106L29.4242 37.9792C28.7692 37.9609 28.1574 37.9451 27.6151 37.9347L26.8592 37.9202C26.0195 37.9045 25.4693 37.8993 25.4051 37.8993H25.3868C25.3449 37.8993 24.9663 37.8993 24.365 37.9124C23.0065 37.9333 20.3629 37.9884 17.9303 38.1141L17.2451 38.1508C16.4919 38.1954 15.3063 38.2543 13.7173 38.3277L12.5226 38.3827L8.73929 38.5477C6.44155 38.646 4.31542 38.7338 3.15476 38.7809L2.30981 30.8305C3.88181 29.6371 4.53681 28.4319 5.22325 27.1625C5.38307 26.8665 5.54813 26.5625 5.73022 26.2455L5.74594 26.2167C5.94899 25.8355 6.22147 25.3364 6.53194 24.8622C7.51706 23.3491 9.64057 21.1391 10.6584 20.1108C10.7659 20.1946 10.8785 20.289 10.9925 20.3898C11.1065 20.4907 11.2217 20.5968 11.341 20.7121C11.4602 20.8274 11.5807 20.9466 11.7051 21.0736C12.1387 21.5204 12.6221 22.0601 13.2627 22.8251C13.3937 22.9863 13.5365 23.1513 13.6741 23.3177L14.0946 23.8233L14.7404 24.6002L15.1819 25.1242C15.6011 25.6194 15.9744 26.0412 16.3203 26.4342C18.7647 29.1315 24.5733 33.3208 24.8182 33.4977C24.9852 33.6183 25.186 33.6833 25.392 33.6833C25.598 33.6833 25.7988 33.6183 25.9658 33.4977C26.2121 33.3208 32.0193 29.1315 34.4651 26.4342C34.6838 26.1918 34.9092 25.9364 35.1541 25.6482C35.3043 25.4735 35.4537 25.2988 35.6022 25.1242C35.7502 24.9499 35.8969 24.7744 36.0436 24.6002C36.2558 24.346 36.4654 24.0919 36.6737 23.8417C37.1781 23.2325 37.6549 22.6627 38.1239 22.119C38.6422 21.5071 39.1992 20.9291 39.7915 20.3885C39.9055 20.2877 40.0182 20.1933 40.1256 20.1095C41.1421 21.1365 43.2696 23.3465 44.2521 24.8609C44.5626 25.3351 44.835 25.8342 45.0381 26.2154L45.0538 26.2442C45.2359 26.5599 45.401 26.8638 45.5608 27.1612C46.2485 28.4319 46.9022 29.6371 48.4742 30.8292L47.6384 38.7809Z"
            fill="#18181e"
          />
        </svg>
      );
    case 'undie':
      return (
        <svg
          width="67"
          height="56"
          viewBox="0 0 67 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.8777 28.0686L9.7023 27.8044C9.88772 26.2772 10.3505 20.7555 8.5343 13.8C6.51658 6.08247 1.00362 5.47803 0.77002 5.45613L0.953976 3.27344C1.24598 3.29826 8.22916 3.9684 10.6542 13.2467C12.5172 20.3759 12.1303 25.9867 11.8777 28.0686Z"
            fill="black"
          />
          <path
            d="M16.3231 30.1025H16.1406C16.0388 30.1054 15.9369 30.097 15.8369 30.0777L10.6174 29.0367C10.5168 29.0176 10.4188 28.9867 10.3254 28.9448C7.0959 27.714 4.446 23.6012 2.44142 16.7173C0.860238 11.2364 0.211998 5.82128 0.0922784 4.78614C0.0689364 4.58262 0.0812883 4.37659 0.128778 4.17732C0.16122 4.03598 0.215399 3.90054 0.289379 3.77582C0.320442 3.72164 0.355584 3.6699 0.394499 3.62106L0.41348 3.59624L2.62538 0.946342C2.82182 0.710308 3.09232 0.547656 3.3929 0.484834C3.69349 0.422013 4.00649 0.462713 4.28102 0.600318C4.33358 0.626598 9.7312 3.27066 18.0678 4.98032C26.454 6.60384 32.532 6.24614 32.5933 6.24322C32.899 6.22207 33.2028 6.30489 33.4554 6.47824C33.708 6.65159 33.8945 6.90527 33.9847 7.19806L35.0213 10.5225C35.038 10.5828 35.0502 10.6443 35.0578 10.7064C35.0817 10.8515 35.0817 10.9994 35.0578 11.1444C35.0255 11.3458 34.9583 11.54 34.8593 11.7182C34.357 12.6263 31.6794 17.3772 28.1097 21.8273C23.6976 27.3198 19.7351 30.1025 16.3231 30.1025ZM16.1771 27.9125C21.7353 28.1082 29.4266 16.9552 32.8211 10.8554L32.075 8.46096C30.2354 8.50914 24.7079 8.50622 17.6386 7.13674L17.7846 6.36586L17.6269 7.13528C10.5692 5.68988 5.55268 3.59624 3.89412 2.84872L2.28812 4.77154C3.0882 11.708 5.9206 24.9604 11.1255 26.9081L16.1771 27.9125Z"
            fill="black"
          />
          <path
            d="M17.148 29.2893L15.0398 28.7053C15.6034 26.6861 17.3977 21.3556 21.8522 15.485C27.66 7.84042 34.3571 9.8961 34.6388 9.98808L33.9731 12.073C33.7482 12.0043 28.4251 10.448 23.6071 16.8034C19.2577 22.5295 17.5685 27.8088 17.148 29.2893Z"
            fill="black"
          />
          <path
            d="M31.2093 55.5383C29.6238 55.5383 28.0406 55.5004 26.4599 55.4245L25.3503 55.3704L26.768 33.0324C26.7538 32.6584 26.705 32.2864 26.622 31.9214L25.7066 27.3647L55.7826 21.3218L56.7141 26.0128C56.7824 26.3687 56.886 26.7169 57.0236 27.0523L57.5025 28.0188C57.5208 28.0515 57.5373 28.0851 57.5521 28.1195L66.9165 47.0149L65.9121 47.4937C60.8336 49.9133 55.5586 51.8968 50.1441 53.4228L48.7906 53.8039L45.456 47.8383L44.6851 54.6288L43.2894 54.801C39.2814 55.292 35.2472 55.5382 31.2093 55.5383ZM27.6761 53.2841C32.6973 53.4668 37.725 53.2598 42.7141 52.6651L43.5741 45.0979C43.6074 44.8074 43.7319 44.5349 43.9298 44.3197C44.1277 44.1044 44.3887 43.9574 44.6753 43.8999C44.962 43.8423 45.2596 43.877 45.5252 43.9992C45.7909 44.1213 46.011 44.3245 46.1539 44.5796L49.871 51.227C54.7001 49.8485 59.4149 48.0976 63.9732 45.9899L55.0672 28.0319C54.8448 27.5251 54.6788 26.9953 54.5722 26.4522L54.0583 23.9118L28.282 29.0861L28.7667 31.4951C28.9726 32.5171 28.9741 33.05 28.9449 33.3069L27.6761 53.2841Z"
            fill="black"
          />
          <path
            d="M55.5312 25.6552L27.6028 31.4897L28.0506 33.6335L55.979 27.7989L55.5312 25.6552Z"
            fill="black"
          />
        </svg>
      );
    case 'undie_alt':
      return (
        <svg
          width="41"
          height="26"
          viewBox="0 0 41 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.9325 3.92367C15.3789 10.2711 17.188 17.3777 17.1961 24.6004V24.809H23.6527V24.6004C23.6611 17.3343 25.492 10.1864 28.9778 3.81104"
            stroke="black"
            strokeWidth="1.56436"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.9214 2.20605C34.0692 6.18475 31.6861 16.5826 23.639 24.809"
            stroke="black"
            strokeWidth="1.56436"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.7523 2.00562C6.61807 5.82579 8.94376 16.4395 17.1306 24.8088"
            stroke="black"
            strokeWidth="1.56436"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.7093 1.1183C39.7093 1.1183 36.3324 1.99121 36.0164 2.0152L20.4134 5.50581L4.81048 2.01311L1.29066 1.11621"
            stroke="black"
            strokeWidth="1.56436"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'lingerie_sleep':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="50"
          fill="none"
        >
          <rect
            id="backgroundrect"
            width="100%"
            height="100%"
            x="0"
            y="0"
            fill="none"
            stroke="none"
          />

          <g className="currentLayer">
            <title>Layer 1</title>
            <g id="svg_9">
              <path
                d="M22.591600715255737,25.307000654983526 L20.233700715255743,29.496400654983518 "
                stroke="#18181e"
                strokeWidth="1.845"
                strokeLinejoin="round"
                id="svg_8"
              />
              <path
                d="M25.000000715255737,5.000900654983518 H16.72820071525574 C15.962300715255736,5.000900654983518 15.21820071525574,5.255500654983521 14.612800715255737,5.724600654983519 C14.007400715255734,6.193800654983519 13.575100715255736,6.850800654983523 13.383900715255734,7.5925006549835174 L7.780000715255738,29.27990065498353 C8.924900715255742,29.611000654983513 10.14650071525574,29.560400654983525 11.260000715255735,29.13560065498352 C12.37360071525574,28.71090065498352 13.31860071525574,27.935100654983515 13.952100715255739,26.92560065498352 L14.136600715255739,26.63170065498352 L15.461400715255735,18.33290065498352 L15.549900715255738,13.47680065498352 "
                stroke="#18181e"
                strokeWidth="1.845"
                strokeLinejoin="round"
                id="svg_1"
              />
              <path
                d="M25.000000715255737,5.000900654983518 H33.271800715255736 C34.03770071525574,5.000900654983518 34.78180071525574,5.255500654983521 35.387200715255744,5.724600654983519 C35.99260071525573,6.193800654983519 36.42490071525573,6.850800654983523 36.61610071525574,7.5925006549835174 L42.220000715255736,29.27990065498353 C41.07510071525574,29.611000654983513 39.853500715255734,29.560400654983525 38.74000071525573,29.13560065498352 C37.62640071525574,28.71090065498352 36.681400715255734,27.935100654983515 36.047900715255736,26.92560065498352 L35.863400715255736,26.63170065498352 L34.53860071525574,18.33290065498352 L34.45010071525574,13.47680065498352 "
                stroke="#18181e"
                strokeWidth="1.845"
                strokeLinejoin="round"
                id="svg_2"
              />
              <path
                d="M15.465000715255748,18.33270065498352 C15.465000715255748,18.33270065498352 15.420800715255737,20.14200065498352 17.231300715255735,22.48150065498352 V25.310500654983528 C17.231300715255735,25.310500654983528 13.74300071525574,32.28580065498352 13.037000715255736,36.61170065498352 C12.60520071525574,39.386200654983526 12.399600715255744,42.19120065498352 12.422000715255734,44.99910065498352 H25.000000715255737 "
                stroke="#18181e"
                strokeWidth="1.845"
                strokeLinejoin="round"
                id="svg_3"
              />
              <path
                d="M34.535000715255734,18.33270065498352 C34.535000715255734,18.33270065498352 34.57920071525574,20.14200065498352 32.76870071525573,22.48150065498352 V25.310500654983528 C32.76870071525573,25.310500654983528 36.25700071525574,32.28580065498352 36.96300071525573,36.61170065498352 C37.39480071525574,39.386200654983526 37.60040071525573,42.19120065498352 37.57800071525574,44.99910065498352 H25.000000715255737 "
                stroke="#18181e"
                strokeWidth="1.845"
                strokeLinejoin="round"
                id="svg_4"
              />
              <path
                d="M19.879500715255737,5.000900654983518 C19.879500715255737,5.000900654983518 18.907800715255732,9.55190065498352 22.969300715255734,16.08070065498353 C27.03070071525574,22.609600654983524 29.365300715255742,25.630400654983525 29.365300715255742,25.630400654983525 C29.365300715255742,25.630400654983525 26.848700715255738,41.50850065498352 26.93720071525574,44.99560065498352 "
                stroke="#18181e"
                strokeWidth="1.845"
                strokeLinejoin="round"
                id="svg_5"
              />
              <path
                d="M30.296400715255743,5.000900654983518 C30.296400715255743,5.000900654983518 31.266900715255744,9.55190065498352 27.205400715255735,16.08070065498353 C26.437100715255742,17.318100654983517 25.731000715255732,18.43080065498352 25.087300715255736,19.418900654983517 "
                stroke="#18181e"
                strokeWidth="1.845"
                strokeLinejoin="round"
                id="svg_6"
              />
              <path
                d="M17.231300715255735,25.307000654983526 H32.76870071525573 "
                stroke="#18181e"
                strokeWidth="1.845"
                strokeLinejoin="round"
                id="svg_7"
              />
            </g>
          </g>
        </svg>
      );
    default:
      return null;
  }
};

export default Icon;
